import axiosInstance from "../config/axiosConfig";

export const addPayment = async (paymentData) => {
    try {
        return await axiosInstance.post("/api/payment", paymentData);
    } catch (error) {
        throw error;
    }
};
